export const LiveControlsTestIDs = {
  liveControlsBackground: 'live_video_controls_background',
  liveControlsMenuUnderlay: 'live_video_controls_menu_underlay',
  liveControlsANFTileList: 'live_video_controls_anf_list',
  currentShowTitle: 'live_video_controls_current_show_title',
  currentShowTime: 'live_video_controls_current_show_time',
  nextShowTitle: 'live_video_controls_next_show_title',
  nextShowTime: 'live_video_controls_next_show_time',
  closedCaptionsButton: 'live_video_controls_cc_button',
  liveVideoControls: 'live_video_controls',
  showLiveVideoControls: 'live_video_controls_handle',
  liveVideoControlsExit: 'live_video_controls_exit',
};

export const VODControlsTestIDs = {
  vodControlsBackground: 'vod_video_controls_background',
  title: 'vod_video_controls_show_title',
  subtitle: 'vod_video_controls_show_subtitle',
  duration: 'vod_video_controls_time_duration',
  closedCaptionsButton: 'vod_video_controls_cc_button',
  playPauseButton: 'vod_video_controls_play_pause_button',
  vodPlayList: 'vod_video_controls_playlist',
  vodVideoControls: 'vod_video_controls',
  playNextButton: 'vod_video_controls_autoplay_button',
  playNextTitle: 'vod_video_controls_autoplay_title',
  playNextSubtitle: 'vod_video_controls_autoplay_subtitle',
};
